export default {
  'EditableTextInput.save': {
    en: 'Save Change',
    fr: 'Sauvegarder les modifications',
  },
  'EditableTextInput.cancel': { en: 'Cancel', fr: 'Annuler' },
};
